import script from "./addressInfoTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./addressInfoTemp.vue?vue&type=script&setup=true&lang=js"

import "./addressInfoTemp.vue?vue&type=style&index=0&id=3c034a44&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c034a44"]])

export default __exports__